var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row container center red move-down padding z-depth-4"},[_c('h3',{staticClass:"white-text"},[_vm._v("Try Again!")])])}]

export { render, staticRenderFns }